import { useRef } from "react";

export const SpotlightCard = ({ children, className = "", testid, color = "21,179,81" }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      onMouseMove={onMove}
      className={`gp-spotlight group relative overflow-hidden ${className}`}
      style={{ "--spot": color }}
    >
      <span className="gp-spotlight-glow" aria-hidden />
      <div className="relative z-10">{children}</div>
    </div>
  );
};
